import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/antd/Sidebar';
import { Layout } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { MenuOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import { getAllReportsByProject } from '../../actions/reportActions';
import { getAccountById } from '../../actions/accountActions';
import { getAdminProfile } from '../../actions/authActions';
import './index.css';
import ValidationTable from '../../components/antd/ValidationTable';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import logo from '../../images/d-insight-logo.png';
import MultiTabReportTable from '../../components/antd/MultiTabReportTable';
import { FiLogIn } from 'react-icons/fi';
import SummaryDashboard from '../adminDashboard/components/SummaryDashboard';
import DatabaseEditTable from '../adminDashboard/DatabaseEditTable';
import UploadCSV from '../adminDashboard/UploadCSV';

const { Header, Sider, Content } = Layout;

function AdminHomeDashboard({ match }) {
  const searchParams = useParams();
  const { id } = searchParams;
  const location = useLocation();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [curReport, setCurReport] = useState('');
  const [projectId, setProjectId] = useState('');
  const [updated, setUpdated] = useState(false);
  const [filteredReports, setFilteredReports] = useState([]);
  const [filter, setFilter] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [hasAccess, setHasAccess] = useState(true);
  const [loggedInUser] = useState(location.state);

  // console.log(' location.state.number', loggedInUser)

  useEffect(() => {
    if (!loggedInUser) {
      return navigate(
        `/admin/login/${id}?project=${userProfile && userProfile.slug}`
      );
    }
  }, []);

  useEffect(() => {
    if (id) {
      setProjectId(id);
      dispatch(getAllReportsByProject(id));
      dispatch(getAdminProfile({ projectId: id }));
    }
  }, [dispatch, id, loggedInUser]);

  useEffect(() => {
    // get current user by local storage
    if (loggedInUser) {
      // get account
      dispatch(getAccountById(loggedInUser._id));
    }
  }, [loggedInUser, dispatch]);

  const accountData = useSelector((state) => state.accountR);
  const { userProfile } = useSelector((state) => state.authR);
  const { loading, reports } = useSelector((store) => store.reportR);

  // console.log('accountData', accountData);

  useEffect(() => {
    // console.log('error hit');
    if (accountData.error) {
      // console.log('acc', accountData);
      if (accountData.error === 'Token is not valid') {
        Swal.fire({
          title: 'Oops,',
          text: ` ${accountData.error}`,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Ok',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(`/admin/login/${projectId}`);
          }
        });
      } else {
        Swal.fire('Oops...', `${accountData.error}`, 'error');
      }
    }
  }, [accountData.error, projectId, navigate]);

  useEffect(() => {
    if (accountData.account && reports) {
      setHasAccess(true);
      const report2Access = [];
      accountData.account.report2Access &&
        accountData.account.report2Access.map((e) =>
          report2Access.push(e.value)
        );
      const filtered = reports.filter((e) => report2Access.includes(e._id));
      setFilteredReports(filtered);

      if (!filtered || !filtered.length) {
        setHasAccess(false);
      }

      // setting current report for refresh page
      const currR = JSON.parse(localStorage.getItem('curReport'));

      if (currR) {
        const cur = filtered.find((e) => e._id === currR._id);

        if (cur) {
          setCurReport(cur);
        } else {
          setCurReport(filtered && filtered[0]);
        }
      } else {
        filtered[0] &&
          localStorage.setItem('curReport', JSON.stringify(filtered[0]));
        setCurReport(filtered[0]);
      }
      setUpdated(true);
      setFilter(false);
    }
  }, [accountData.account, reports]);

  function getCurrentReport(report) {
    if (!report) {
      setCurReport('');
      setUpdated(false);
      setFilter(false);
      return;
    }
    localStorage.setItem('curReport', JSON.stringify(report));
    setCurReport(report);
    setUpdated(true);
    setFilter(false);
  }

  const logOutUser = () => {
    localStorage.removeItem('centralize-admin-token');
    localStorage.removeItem('centralize-admin-data');
    localStorage.removeItem('selected-database');
    localStorage.removeItem('current-report');
    localStorage.removeItem('curReport');

    // this redirect to drive projects main page
    if (loggedInUser && loggedInUser.token) {
      return navigate(`/drive/projects?token=${loggedInUser.token}`);
    } else {
      return navigate(
        `/admin/login/${projectId}?project=${userProfile && userProfile.slug}`,
        { state: {} }
      );
    }
  };

  // console.log(curReport && curReport.name)

  return (
    <div>
      <Layout hasSider>
        <Sider
          className="sidebar-sider"
          trigger={null}
          collapsible
          collapsed={collapsed}
        >
          <div
            onClick={() => setCollapsed(!collapsed)}
            style={{ color: '#fff', padding: '1rem' }}
          >
            <MenuOutlined style={{ fontSize: '1.5rem' }} />
          </div>

          <div className="sidebar-menu-logo">
            <div className="logo-text">
              <img
                src={
                  userProfile && userProfile.logoBigUrl
                    ? userProfile.logoBigUrl.replace('ap-southeast', 'us-west')
                    : logo
                }
                alt="logo"
                className="logo"
                style={{ width: collapsed ? '100%' : '80%' }}
              />
              {collapsed ? null : <div>Admin Portal</div>}
            </div>
          </div>

          <div className="d-flex flex-column justify-content-between">
            <div style={{ minHeight: '60vh' }}>
              <Sidebar
                getCurrentReport={getCurrentReport}
                filteredReports={filteredReports}
              />
            </div>

            <div
              className="logout-container d-flex align-items-center justify-content-center py-4"
              onClick={logOutUser}
            >
              <div className="mx-2">
                <FiLogIn size="1.3rem" />
              </div>
              {collapsed ? null : (
                <div style={{ cursor: 'pointer' }}>Log Out</div>
              )}
            </div>
          </div>
        </Sider>
        <Layout
          className="site-layout"
          style={{ marginLeft: collapsed ? 80 : 200 }}
        >
          <Header className="header-content d-flex justify-content-between">
            <div> {curReport && curReport.name}</div>

            <div style={{ marginRight: '20%', textTransform: 'capitalize' }}>
              {loggedInUser && loggedInUser.username}{' '}
            </div>
          </Header>

          <Content className="content-container">
            <div>
              {!loading && !hasAccess ? (
                <h4 className="text-danger text-center fw-bold">
                  You have no access to any report.
                  <div>
                    <small>Contact admin to give you access.</small>
                  </div>
                </h4>
              ) : (
                ''
              )}
            </div>
            {curReport &&
            (curReport.reportType === 'receipt-validation' ||
              curReport.reportType === 'Action' ||
              curReport.reportType === 'action-without-receipt' ||
              curReport.reportType === 'Non Action') ? (
              <ValidationTable
                loggedInUser={loggedInUser}
                report={curReport}
                projectId={projectId}
                filter={filter}
                setFilter={setFilter}
                loading2={loading}
                projectName={userProfile && userProfile.title}
              />
            ) : null}
            {curReport && curReport.reportType === 'multi-tabs-report' ? (
              <MultiTabReportTable
                loggedInUser={loggedInUser}
                report={curReport}
                projectId={projectId}
                filter={filter}
                setFilter={setFilter}
                loading2={loading}
                projectName={userProfile && userProfile.title}
              />
            ) : null}

            {curReport && curReport.reportTag === 'summaryDashboard' ? (
              <SummaryDashboard
                report={curReport}
                projectId={projectId}
                updated={updated}
                setUpdated={setUpdated}
                filter={filter}
                setFilter={setFilter}
                projectName={userProfile && userProfile.title}
              />
            ) : null}

            {curReport && curReport.name === 'updateDb' ? (
              <DatabaseEditTable
                loggedInUser={loggedInUser}
                report={curReport}
                projectId={projectId}
                updated={updated}
                setUpdated={setUpdated}
                projectName={userProfile && userProfile.title}
              />
            ) : null}

            {curReport && curReport.reportType === 'upload-csv' ? (
              <UploadCSV
                loggedInUser={loggedInUser}
                report={curReport}
                projectId={projectId}
                updated={updated}
                setUpdated={setUpdated}
                projectName={userProfile && userProfile.title}
              />
            ) : null}
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default AdminHomeDashboard;
